// extracted by mini-css-extract-plugin
export default {"container":"styles_container__OLs1s","paragraph":"styles_paragraph__Bz+a-"};